export default {"src":"/_next/static/media/trust.faf7642c.svg","height":116,"width":116,"blurWidth":0,"blurHeight":0};